var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comps"},[_c('span',{staticClass:"phead"},[_vm._v("NO COMPETITIONS ARE AVAILIBLE RIGHT NOW.")])])}]

export { render, staticRenderFns }